import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { GetDemoDataStatusAPI } from '../../api/API';
import overlay from './GuidedTourOverlay.module.css';
import styles from './GuidedTourSummary.module.css';

// Cada linha: chave de week (DemoDataStatus::weekSummary), singular, plural e o que a Gabriela fez
const LINES = [
  { key: 'reminders', icon: <NotificationsActiveOutlinedIcon />, one: 'lembrete enviado', many: 'lembretes enviados', hint: 'na véspera, pelo WhatsApp, com a mensagem pronta' },
  { key: 'confirmations', icon: <EventAvailableOutlinedIcon />, one: 'confirmação recebida', many: 'confirmações recebidas', hint: 'a agenda muda de cor sozinha' },
  { key: 'avoided_noshows', icon: <EventRepeatOutlinedIcon />, one: 'falta evitada', many: 'faltas evitadas', hint: 'avisou antes ou remarcou, e o horário ficou livre' },
  { key: 'pending_payments', icon: <ReceiptLongOutlinedIcon />, one: 'pagamento pendente avisado', many: 'pagamentos pendentes avisados', hint: 'atendimento realizado sem pagamento registrado' },
];

/**
 * Parada "O que a Gabriela fez por você" do guia Conheça sua conta (summary: true em
 * tourScripts.js): resumo simulado da semana, com os números dos próprios exemplos
 * (get_status.php, campo week). Só leitura: nada é enviado nem gravado.
 */
function GuidedTourSummary({ step, eyebrow, onNext, onStop }) {
  const [week, setWeek] = useState(null);

  useEffect(() => {
    let alive = true;
    GetDemoDataStatusAPI((response) => {
      if (alive) setWeek(response?.success && response.week ? response.week : {});
    });
    return () => { alive = false; };
  }, []);

  const lines = week ? LINES.filter((line) => Number(week[line.key]) > 0) : [];

  return createPortal(
    <div className={overlay.backdrop}>
      <div className={`${overlay.celebrate} ${styles.card}`} role="dialog" aria-modal="true" aria-label={step.title} data-tour-balloon="">
        <span className={styles.eyebrow}>{eyebrow}</span>
        <strong className={overlay.celebrateTitle}>{step.title}</strong>
        <p className={overlay.celebrateText}>{step.text}</p>

        {!week && <span className={overlay.savingSpinner} aria-hidden="true" />}
        {week && lines.length > 0 && (
          <ul className={styles.list}>
            {lines.map((line) => {
              const value = Number(week[line.key]);
              return (
                <li key={line.key} className={styles.line}>
                  <span className={styles.icon}>{line.icon}</span>
                  <span className={styles.body}>
                    <strong>{value} {value === 1 ? line.one : line.many}</strong>
                    <span>{line.hint}</span>
                  </span>
                </li>
              );
            })}
          </ul>
        )}
        {week && lines.length === 0 && (
          <p className={styles.empty}>
            Com a agenda em uso, aqui aparecem os lembretes enviados, as confirmações recebidas,
            as faltas evitadas e os pagamentos pendentes da semana.
          </p>
        )}

        <div className={overlay.celebrateActions}>
          <button type="button" className={overlay.linkButton} onClick={onStop}>Sair do guia</button>
          <button type="button" className={overlay.primaryButton} onClick={onNext}>
            {step.next || 'Próximo'} <ArrowForwardIcon fontSize="small" />
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default GuidedTourSummary;
